import { f as fetchHTML } from './index-Da0J-i1G.js';
import { pubsub } from '@services';

class StickyProductForm extends HTMLElement {
  button = this.querySelector('button[type="submit"]');
  productForm = document.querySelector('product-form');
  footerContent = document.querySelector('#footer-content');
  elementsToObserve = [this.productForm, this.footerContent];

  connectedCallback() {
    this.observeElements();

    pubsub.subscribe(`variant:changed:${this.dataset.productId}`, ({ variantId, html }) => {
      this.fetchSection(variantId);
      this.observeElements();

      const productForm = html.querySelector('product-form');
      if (productForm && this.button) {
        const formButton = productForm.querySelector('button[type="submit"]');
        if (!formButton) return;

        this.button.disabled = formButton.disabled;
        this.button.textContent = formButton.textContent;
      }
    });
  }

  disconnectedCallback() {
    this.unsubscribeVariantChanged();
  }

  /**
   * Fetch the section.
   * @param {String} variantId - The variant ID.
   */
  async fetchSection(variantId) {
    const { sectionId } = this.dataset;

    const params = [`section_id=${sectionId}`, `variant=${variantId}`].join('&');

    try {
      const html = await fetchHTML(`${window.location.pathname}?${params}`);
      const parsedStickAddToCart = html.querySelector('sticky-add-to-cart');

      if (!parsedStickAddToCart) return;

      const contentContainer = parsedStickAddToCart.querySelector('div[class*="flex"]');
      const currentContainer = this.querySelector('div[class*="flex"]');

      if (contentContainer && currentContainer) {
        currentContainer.innerHTML = contentContainer.innerHTML;
        this.button = this.querySelector('button[type="submit"]');
        this.dataset.variantId = variantId;
      } else {
        // Fallback to full replacement if elements not found
        this.outerHTML = parsedStickAddToCart.outerHTML;
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Update sticky add to cart visibility based on both observers
   */
  updateVisibility(isIntersecting) {
    ['translate-y-full', 'opacity-0'].forEach((className) => {
      this.classList.toggle(className, isIntersecting);
    });
  }

  observeElements() {
    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = entries.some(({ isIntersecting }) => isIntersecting);
      this.updateVisibility(isIntersecting);
    });

    this.elementsToObserve.forEach((element) => element && observer.observe(element));
  }
}

customElements.define('sticky-add-to-cart', StickyProductForm);
